/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SymptomAttributePreference from './symptom-attribute-preference';
import SymptomAttributePreferenceDetail from './symptom-attribute-preference-detail';
import SymptomAttributePreferenceUpdate from './symptom-attribute-preference-update';
import SymptomAttributePreferenceDeleteDialog from './symptom-attribute-preference-delete-dialog';

const SymptomAttributePreferenceRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SymptomAttributePreference />} />
    <Route path="new" element={<SymptomAttributePreferenceUpdate />} />
    <Route path=":id">
      <Route index element={<SymptomAttributePreferenceDetail />} />
      <Route path="edit" element={<SymptomAttributePreferenceUpdate />} />
      <Route path="delete" element={<SymptomAttributePreferenceDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SymptomAttributePreferenceRoutes;
